import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";

export const getIncomeSummary = createAsyncThunk('incomeStatement/getIncomeSummary',
  async ({ params }: any) => {
    const paramText = new URLSearchParams(params)
    const url = `v1/reports/income-statements/summary?${paramText}`
    const response: AxiosResponse<IncomeSummary> = await instance.get(url)
    return response.data
  })

export const getIncomeStatementBookings = createAsyncThunk('incomeStatement/getIncomeStatementBookings',
  async ({ params }: any) => {
    const paramText = new URLSearchParams(params)
    const url = `v1/reports/income-statements/bookings?${paramText}`
    const response: AxiosResponse<GeneralArrayResponse<IncomeStatementBookingItem>> = await instance.get(url)
    return response.data
  })
